import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import Loading from 'components/pure/utils/Loading';
import DepartmentContextHeader from 'components/pure/admin/DepartmentContextHeader';
import DepartmentActions from 'actions/department/DepartmentActions';
import DepartmentFormStore from 'stores/department/DepartmentFormStore';
import {departmentProfiles} from 'utils/const';

@connectToStores
export default class DepartmentContextContainer extends React.PureComponent {
  componentDidMount() {
    DepartmentActions.fetchDepartment(this.props.params.departmentId);
  }
  static getStores(props) {
    return [DepartmentFormStore];
  }
  static getPropsFromStores(props) {
    return {DepartmentFormStore: DepartmentFormStore.getState()};
  }
  render() {
    // This is a little messy.  Could probably be better:
    // Pull the profile type out of the url path: e.g.
    // /admin/departments/:departmentId/archivingProfiles/new
    // type would be 'archivingProfiles'
    const pathes = window.location.pathname.split('/');
    const path = pathes[4];
    const profile = Object.values(departmentProfiles).find(profile => profile.pluralized === path);
    return (
      <div className="department-context">
        {this.props.DepartmentFormStore.isDepartmentLoading ? (
          <Loading />
        ) : (
          <DepartmentContextHeader
            modelLabel={profile.label}
            department={this.props.DepartmentFormStore.department}
          />
        )}
        <div>{this.props.children}</div>
      </div>
    );
  }
}
